import globals from "./globals";

let exports = {};

class SessionManager {
    constructor(session, dispatcher) {
        if (!session || !dispatcher) {
            throw new Error("SessionManager started with no session or dispatcher.");
        }

        this.session = session;
    }

    getLoginPath() {
        return this.session.loginPath;
    }
}

exports.getLoginPath = function() {
    if (globals.sessionManager) {
        return globals.sessionManager.getLoginPath();
    }
    return null;
};

exports.getInstance = function(session, dispatcher) {
    if (globals.sessionManager) {
        return globals.sessionManager;
    }
    globals.sessionManager = new SessionManager(session, dispatcher);
    return globals.sessionManager;
};

exports.SessionManager = SessionManager;

export default exports;
